"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvertedRankingChartFactory = void 0;
var lineChartYearFactory_1 = require("./lineChartYearFactory");
var lodash_1 = __importDefault(require("lodash"));
var util_1 = require("./util");
var InvertedRankingChartFactory = /** @class */ (function (_super) {
    __extends(InvertedRankingChartFactory, _super);
    function InvertedRankingChartFactory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InvertedRankingChartFactory.prototype.configAxes = function (categoryAxis, valueAxis) {
        var _a;
        _super.prototype.configAxes.call(this, categoryAxis, valueAxis);
        valueAxis.renderer.inversed = true;
        // disable zero line
        valueAxis.renderer.baseGrid.disabled = true;
        // https://www.amcharts.com/docs/v4/tutorials/custom-valueaxis-grid-using-ranges/
        valueAxis.renderer.grid.template.disabled = true;
        valueAxis.renderer.labels.template.disabled = true;
        var createGrid = util_1.createAxisGrid(valueAxis);
        createGrid(1);
        createGrid(50);
        createGrid(100);
        createGrid(150);
        createGrid(200);
        createGrid(250);
        createGrid(290);
        valueAxis.min = 0;
        valueAxis.extraMin = 0.02;
        valueAxis.max = 290;
        valueAxis.extraMax = 0.03;
        valueAxis.strictMinMax = true;
        // overwrite title based on year interval
        var mainTitle = (_a = valueAxis.chart.titles.values) === null || _a === void 0 ? void 0 : _a[0];
        if (mainTitle) {
            var years = this.props.data.map(function (entry) { return entry.year; });
            mainTitle.text = "Rankingutveckling " + lodash_1.default.min(years) + "-" + lodash_1.default.max(years);
        }
    };
    return InvertedRankingChartFactory;
}(lineChartYearFactory_1.LineChartYearFactory));
exports.InvertedRankingChartFactory = InvertedRankingChartFactory;
